import PropTypes from 'prop-types'

export const formik = PropTypes.shape({
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
})

export default {
  className: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  descriptionPosition: PropTypes.oneOf(['top', 'bottom', 'inline']),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.object]),
  labelLocation: PropTypes.oneOf(['before', 'after']),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  tooltip: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
}
